import { IDriveOneSpeed } from '../DriveOneSpeed';

export interface IEHeat extends IDriveOneSpeed {
}

export const schema = 'AutomationApps.Devices.Drives.EHeat'